import FileName from '../ComControl/FileName'
import AvgButtonIndex from '../ComControl/AvgButtonIndex'
import AvgButton from '../ComControl/AvgButton'
import { FileReader, FileWriter } from '@/platform'
import DataUtils from '../DataUtils'

class GameSettingData {
    /**
     * 背景图
     */
    public BackPic: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' })

    /**
     * 选择条底部
     */
    public BarNone: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' })

    /**
     * 选择条上部
     */
    public BarMove: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' })

    /**
     * 关闭按钮  priject_bin_no
     */
    public Close: AvgButton = new AvgButton()

    /**
     * 关闭按钮索引
     */
    public CloseEx: AvgButtonIndex = new AvgButtonIndex()

    /**
     * 返回标题画面按钮  priject_bin_no
     */
    public Title: AvgButton = new AvgButton()

    /**
     * 标题按钮索引
     */
    public TitleEx: AvgButtonIndex = new AvgButtonIndex()

    /**
     * 自动播放按钮  priject_bin_no
     */
    public AutoText_on: AvgButton = new AvgButton()

    /**
     * 自动播放按钮索引
     */
    public AutoText_onEx: AvgButtonIndex = new AvgButtonIndex()

    /**
     * 自动播放按钮   priject_bin_no
     */
    public AutoText_off: AvgButton = new AvgButton()

    /**
     * 自动播放按钮索引 关闭
     */
    public AutoText_offEx: AvgButtonIndex = new AvgButtonIndex()

    /**
     * 全屏   priject_bin_no
     */
    public FullScreen: AvgButton = new AvgButton()

    /**
     * 全屏按钮索引
     */
    public FullScreenEx: AvgButtonIndex = new AvgButtonIndex()

    /**
     * 窗口  priject_bin_no
     */
    public WinScreen: AvgButton = new AvgButton()

    /**
     * 窗口按钮索引
     */
    public WinScreenEx: AvgButtonIndex = new AvgButtonIndex()

    /**
     * 全部按钮的索引  priject_bin_no
     */
    public ButtonsIndex: Array<number> = []

    /**
     * 是否全屏
     */
    public IsFullScreen: boolean = false

    /**
     * 是否自动播放
     */
    public IsAutoText: boolean = false

    /**
     * 有无背景音乐
     */
    public IsBGM: boolean = false

    /**
     * 有无音效
     */
    public IsSE: boolean = false

    /**
     * 有无语音
     */
    public IsVoice: boolean = false

    /**
     * 是否返回标题画面
     */
    public IsTitle: boolean = false

    /**
     * 背景音乐的X坐标
     */
    public X_BGM: number = 0

    /**
     * 背景音乐的Y坐标
     */
    public Y_BGM: number = 0

    /**
     * 音效的X坐标
     */
    public X_SE: number = 0

    /**
     * 音效的Y坐标
     */
    public Y_SE: number = 0

    /**
     * 语音的X坐标
     */
    public X_Voice: number = 0

    /**
     * 语音的Y坐标
     */
    public Y_Voice: number = 0

    /**
     * 音乐音量
     */
    public BgmVol: number = 80

    /**
     * 音效音量
     */
    public SeVol: number = 80

    /**
     * 语音音量
     */
    public VoiceVol: number = 80

    constructor(button?: AvgButton[] | FileReader) {
        if (Array.isArray(button)) {
            this.BackPic = new FileName({ type: FileName.DEF_TYPE, name: 'option.png' })
            this.BarNone = new FileName({ type: FileName.DEF_TYPE, name: 'bar_1.png' })
            this.BarMove = new FileName({ type: FileName.DEF_TYPE, name: 'bar_2.png' })
            this.ButtonsIndex = [15, 17, 18, 19, 20, 21]
            this.Close = button[0]!
            this.CloseEx = new AvgButtonIndex(15, this.Close?.X, this.Close?.Y)
            this.Title = button[1]!
            this.TitleEx = new AvgButtonIndex(17, this.Title?.X, this.Title?.Y)
            this.AutoText_on = button[2]!
            this.AutoText_onEx = new AvgButtonIndex(18, this.AutoText_on?.X, this.AutoText_on?.Y)
            this.AutoText_off = button[3]!
            this.AutoText_offEx = new AvgButtonIndex(19, this.AutoText_off?.X, this.AutoText_off?.Y)
            this.FullScreen = button[4]!
            this.FullScreenEx = new AvgButtonIndex(20, this.FullScreen?.X, this.FullScreen?.Y)
            this.WinScreen = button[5]!
            this.WinScreenEx = new AvgButtonIndex(21, this.WinScreen?.X, this.WinScreen?.Y)
            this.IsFullScreen = true
            this.IsAutoText = true
            this.IsBGM = true
            this.IsSE = true
            this.IsVoice = true
            this.IsTitle = true
            this.X_BGM = 290
            this.Y_BGM = 340
            this.X_SE = 290
            this.Y_SE = 367
            this.X_Voice = 290
            this.Y_Voice = 394
        } else if(button instanceof FileReader) {
            this.readBin(button as FileReader)
        } else {
            this.BackPic = new FileName({ type: FileName.DEF_TYPE, name: 'option.png' })
            this.BarNone = new FileName({ type: FileName.DEF_TYPE, name: 'bar_1.png' })
            this.BarMove = new FileName({ type: FileName.DEF_TYPE, name: 'bar_2.png' })
            this.ButtonsIndex = [15, 17, 18, 19, 20, 21]
            this.Close = new AvgButton()
            this.CloseEx = new AvgButtonIndex()
            this.Title = new AvgButton()
            this.TitleEx = new AvgButtonIndex()
            this.AutoText_on = new AvgButton()
            this.AutoText_onEx = new AvgButtonIndex()
            this.AutoText_off = new AvgButton()
            this.AutoText_offEx = new AvgButtonIndex()
            this.FullScreen = new AvgButton()
            this.FullScreenEx = new AvgButtonIndex()
            this.WinScreen = new AvgButton()
            this.WinScreenEx = new AvgButtonIndex()
            this.IsFullScreen = true
            this.IsAutoText = true
            this.IsBGM = true
            this.IsSE = true
            this.IsVoice = true
            this.IsTitle = true
            this.X_BGM = 290
            this.Y_BGM = 340
            this.X_SE = 290
            this.Y_SE = 367
            this.X_Voice = 290
            this.Y_Voice = 394
            this.BgmVol = 80
            this.SeVol = 80
            this.VoiceVol = 80
        }
    }

    /** 与 cg_v3_data GameSettingData @DataStrucrParse 序号 1～31 一致（≥111 时读 BgmVol/SeVol/VoiceVol） */
    readBin(reader: FileReader): void {
        this.BackPic = new FileName(reader)
        this.BarNone = new FileName(reader)
        this.BarMove = new FileName(reader)

        this.Close = new AvgButton()
        this.Close.readBin(reader)
        this.CloseEx = new AvgButtonIndex()
        this.CloseEx.readBin(reader)

        this.Title = new AvgButton()
        this.Title.readBin(reader)
        this.TitleEx = new AvgButtonIndex()
        this.TitleEx.readBin(reader)

        this.AutoText_on = new AvgButton()
        this.AutoText_on.readBin(reader)
        this.AutoText_onEx = new AvgButtonIndex()
        this.AutoText_onEx.readBin(reader)

        this.AutoText_off = new AvgButton()
        this.AutoText_off.readBin(reader)
        this.AutoText_offEx = new AvgButtonIndex()
        this.AutoText_offEx.readBin(reader)

        this.FullScreen = new AvgButton()
        this.FullScreen.readBin(reader)
        this.FullScreenEx = new AvgButtonIndex()
        this.FullScreenEx.readBin(reader)

        this.WinScreen = new AvgButton()
        this.WinScreen.readBin(reader)
        this.WinScreenEx = new AvgButtonIndex()
        this.WinScreenEx.readBin(reader)

        const biLen = reader.readInt()
        this.ButtonsIndex = []
        for (let i = 0; i < biLen; i++) {
            this.ButtonsIndex.push(reader.readInt())
        }

        this.IsFullScreen = reader.readBool()
        this.IsAutoText = reader.readBool()
        this.IsBGM = reader.readBool()
        this.IsSE = reader.readBool()
        this.IsVoice = reader.readBool()
        this.IsTitle = reader.readBool()

        this.X_BGM = reader.readInt()
        this.Y_BGM = reader.readInt()
        this.X_SE = reader.readInt()
        this.Y_SE = reader.readInt()
        this.X_Voice = reader.readInt()
        this.Y_Voice = reader.readInt()

        if (DataUtils.dataVersion >= 111) {
            this.BgmVol = reader.readInt()
            this.SeVol = reader.readInt()
            this.VoiceVol = reader.readInt()
        }
    }

    writeBin(writer: FileWriter): void {
        this.BackPic.writeBin(writer)
        this.BarNone.writeBin(writer)
        this.BarMove.writeBin(writer)
        this.Close.writeBin(writer)
        this.CloseEx.writeBin(writer)
        this.Title.writeBin(writer)
        this.TitleEx.writeBin(writer)
        this.AutoText_on.writeBin(writer)
        this.AutoText_onEx.writeBin(writer)
        this.AutoText_off.writeBin(writer)
        this.AutoText_offEx.writeBin(writer)
        this.FullScreen.writeBin(writer)
        this.FullScreenEx.writeBin(writer)
        this.WinScreen.writeBin(writer)
        this.WinScreenEx.writeBin(writer)
        writer.writeInt(this.ButtonsIndex.length)
        for (let i = 0; i < this.ButtonsIndex.length; i++) {
            writer.writeInt(this.ButtonsIndex[i]!)
        }
        writer.writeBool(this.IsFullScreen)
        writer.writeBool(this.IsAutoText)
        writer.writeBool(this.IsBGM)
        writer.writeBool(this.IsSE)
        writer.writeBool(this.IsVoice)
        writer.writeBool(this.IsTitle)
        writer.writeInt(this.X_BGM)
        writer.writeInt(this.Y_BGM)
        writer.writeInt(this.X_SE)
        writer.writeInt(this.Y_SE)
        writer.writeInt(this.X_Voice)
        writer.writeInt(this.Y_Voice)
        if (DataUtils.dataVersion >= 111) {
            writer.writeInt(this.BgmVol)
            writer.writeInt(this.SeVol)
            writer.writeInt(this.VoiceVol)
        }
    }

    readVersionedOui(reader: FileReader, dataVersion: number): void {
        this.BackPic.readVersionedOui(reader.readObj(reader.readInt()))
        this.BarNone.readVersionedOui(reader.readObj(reader.readInt()))
        this.BarMove.readVersionedOui(reader.readObj(reader.readInt()))

        this.X_BGM = reader.readInt()
        this.Y_BGM = reader.readInt()
        this.X_SE = reader.readInt()
        this.Y_SE = reader.readInt()
        this.X_Voice = reader.readInt()
        this.Y_Voice = reader.readInt()

        this.IsFullScreen = reader.readInt() == 1 ? true : false
        this.IsAutoText = reader.readInt() == 1 ? true : false
        this.IsBGM = reader.readInt() == 1 ? true : false
        this.IsSE = reader.readInt() == 1 ? true : false
        this.IsVoice = reader.readInt() == 1 ? true : false
        this.IsTitle = reader.readInt() == 1 ? true : false

        this.CloseEx.readVersionedOui(reader.readObj(reader.readInt()))
        this.FullScreenEx.readVersionedOui(reader.readObj(reader.readInt()))
        this.WinScreenEx.readVersionedOui(reader.readObj(reader.readInt()))
        this.AutoText_onEx.readVersionedOui(reader.readObj(reader.readInt()))
        this.AutoText_offEx.readVersionedOui(reader.readObj(reader.readInt()))
        this.TitleEx.readVersionedOui(reader.readObj(reader.readInt()))

        if (dataVersion >= 111) {
            this.BgmVol = reader.readInt()
            this.SeVol = reader.readInt()
            this.VoiceVol = reader.readInt()
        }
    }

    writeVersionedOui(writer: FileWriter, dataVersion: number): void {
        writer.writerIntLength()

        this.BackPic.writeVersionedOui(writer)
        this.BarNone.writeVersionedOui(writer)
        this.BarMove.writeVersionedOui(writer)

        writer.writeInt(this.X_BGM)
        writer.writeInt(this.Y_BGM)
        writer.writeInt(this.X_SE)
        writer.writeInt(this.Y_SE)
        writer.writeInt(this.X_Voice)
        writer.writeInt(this.Y_Voice)

        writer.writeInt(this.IsFullScreen ? 1 : 0)
        writer.writeInt(this.IsAutoText ? 1 : 0)
        writer.writeInt(this.IsBGM ? 1 : 0)
        writer.writeInt(this.IsSE ? 1 : 0)
        writer.writeInt(this.IsVoice ? 1 : 0)
        writer.writeInt(this.IsTitle ? 1 : 0)

        this.CloseEx.writeVersionedOui(writer)
        this.FullScreenEx.writeVersionedOui(writer)
        this.WinScreenEx.writeVersionedOui(writer)
        this.AutoText_onEx.writeVersionedOui(writer)
        this.AutoText_offEx.writeVersionedOui(writer)
        this.TitleEx.writeVersionedOui(writer)

        if (dataVersion >= 111) {
            writer.writeInt(this.BgmVol)
            writer.writeInt(this.SeVol)
            writer.writeInt(this.VoiceVol)
        }

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter, engineVersion: number): void {
        writer.writerIntLength()

        this.BackPic.writeVersionedOui(writer)
        this.BarNone.writeVersionedOui(writer)
        this.BarMove.writeVersionedOui(writer)

        writer.writeInt(this.X_BGM)
        writer.writeInt(this.Y_BGM)
        writer.writeInt(this.X_SE)
        writer.writeInt(this.Y_SE)
        writer.writeInt(this.X_Voice)
        writer.writeInt(this.Y_Voice)

        writer.writeInt(this.IsFullScreen ? 1 : 0)
        writer.writeInt(this.IsAutoText ? 1 : 0)
        writer.writeInt(this.IsBGM ? 1 : 0)
        writer.writeInt(this.IsSE ? 1 : 0)
        writer.writeInt(this.IsVoice ? 1 : 0)
        writer.writeInt(this.IsTitle ? 1 : 0)

        this.CloseEx.writeVersionedOui(writer)
        this.FullScreenEx.writeVersionedOui(writer)
        this.WinScreenEx.writeVersionedOui(writer)
        this.AutoText_onEx.writeVersionedOui(writer)
        this.AutoText_offEx.writeVersionedOui(writer)
        this.TitleEx.writeVersionedOui(writer)

        if (engineVersion >= 108) {
            writer.writeInt(this.BgmVol)
            writer.writeInt(this.SeVol)
            writer.writeInt(this.VoiceVol)
        }

        writer.writerLength()
    }
}
export default GameSettingData
